var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { of as observableOf } from 'rxjs';
import { map, filter, withLatestFrom, switchMap } from 'rxjs/operators';
import { OrganisationsApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as actions from '../actions/index';
import * as selectors from '../reducers/index';
export var dashboardRegex = /^\/organisations\/[a-z0-9-]+$/;
var AnnouncementEffects = /** @class */ (function () {
    function AnnouncementEffects(store, actions$, organisationApi) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.organisationApi = organisationApi;
        this.getAnnouncementList = this.actions$
            .ofType(actions.Announcements.REQUEST_ALL).pipe(withLatestFrom(this.store.select(selectors.getSelectedId(selectors.ORGANISATIONS))), switchMap(function (_a) {
            var action = _a[0], org = _a[1];
            return _this.organisationApi
                .getAnnouncement(org)
                .map(function (payload) {
                return actions.Announcements.ResponseSuccessAllAction(payload);
            })
                .catch(function (err) { return observableOf(actions.Announcements.ResponseFailAction(err)); });
        }));
        this.refreshStatistics = this.actions$
            .ofType(actions.Organisations.SELECT_BY_ID).pipe(withLatestFrom(this.store.select(selectors.getRouterState)), filter(function (_a) {
            var action = _a[0], router = _a[1];
            return (router && router.state ? dashboardRegex.test(router.state.url) : false);
        }), map(function (action) { return actions.Announcements.RequestAllAction; }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AnnouncementEffects.prototype, "getAnnouncementList", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], AnnouncementEffects.prototype, "refreshStatistics", void 0);
    return AnnouncementEffects;
}());
export { AnnouncementEffects };
